import { useEffect } from "react";

export default function BookingSuccessful() {
    useEffect(() => {
        const token = localStorage.getItem("TH_AUTH_TOKEN");
        if (!token) window.location.href = "/";
    }, [])
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 py-12 relative">
            {/* Background "Thank You" text */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <h1 className="text-9xl font-bold text-gray-100/50">Thank You</h1>
            </div>

            {/* Main content */}
            <div className="flex flex-col items-center justify-center z-10 max-w-3xl mx-auto">
                {/* Dartboard image */}
                <div className="w-48 h-48 rounded-full overflow-hidden mb-8">
                    <img
                        src="https://develop.nadwa-uae.com/static/media/booking_thanks_target.f10d25ba.png"
                        alt="Dartboard"
                        width={160}
                        height={160}
                        className="object-cover h-full w-full"
                    />
                </div>

                {/* Success message */}
                <h2 className="text-4xl font-semibold text-center mb-6">Your payment is successful!</h2>

                {/* Description */}
                <p className="text-center text-xl mb-8 w-[400px]">
                    Thank you for completing your payment. You can now view the sessions you have booked by visiting the
                    &apos;Bookings&apos; section.
                </p>

                {/* Custom Bookings button without shadcn */}
                <div className="flex gap-4">
                    <button
                        className="bg-[#00732F] text-white font-medium py-2 px-10 rounded-md transition-colors duration-200"
                        onClick={() => window.location.href = "/customer-dashboard#dashboard"}
                    >
                        Go To Dashboard
                    </button>
                    <button
                        className="bg-[#00732F] text-white font-medium py-2 px-10 rounded-md transition-colors duration-200"
                        onClick={() => window.location.href = "/customer-dashboard#booking"}
                    >
                        Bookings
                    </button>
                </div>

            </div>
        </div>
    )
}
